import { render, staticRenderFns } from "./HotProfession.vue?vue&type=template&id=35ff20a4&scoped=true&"
import script from "./HotProfession.vue?vue&type=script&lang=js&"
export * from "./HotProfession.vue?vue&type=script&lang=js&"
import style0 from "./HotProfession.vue?vue&type=style&index=0&id=35ff20a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff20a4",
  null
  
)

export default component.exports